import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { withRouter } from 'react-router-dom';
import Welcome from './Welcome.js';
import TreeView from './TreeView.js';
import Content from './Content.js';
import * as Filter from './Filter.js';
import Util from './Util.js';
import TopBar from './TopBar.js';
import PageFooter from './PageFooter.js';

class Main extends Component {
  constructor(props) {
    super(props);

    let loadingNav = {
      name: this.props.i18n.loading,
      children: [
        {
          name: this.props.i18n.loading,
          children: []
        }]
    };

    this.state = {
      currentPage: null,
      allTreeData: loadingNav,
      treeData: loadingNav,
      menuIsShow: true,
      mobileMenuIsShow: false,
      codeMode: 0
    };

    this.onTreeViewSelect = this.onTreeViewSelect.bind(this);
    this.onSearch = this.onSearch.bind(this);
    this.onClickHome = this.onClickHome.bind(this);
    this.onHClickHideShowMenu = this.onHClickHideShowMenu.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.match.params.demoid) {
      let demoid = nextProps.match.params.demoid;
      this.state.currentPage = Util.FindNodeById(this.state.treeData, demoid);

      const params = new URLSearchParams(nextProps.location.search);
      let devLang = params.get('devLang');
      this.state.codeMode = devLang == 'kotlin' ? 1 : 0;
    }
    else {
      Util.InActiveAll(this.state.treeData);
      this.state.currentPage = null;
    }
  }

  componentDidMount() {
    var self = this;

    let url = this.props.serverUrl;
    if (url.indexOf('/') !== -1) {
      url = url.substr(0, url.length - 1); //drop the last '/'
    }

    //append language option
    let lang = this.props.lang || "en-US";
    url += "?lang=" + lang;

    require('../less/main.' + this.props.lang + ".less");
    require('../less/react-tabs.less');

    var options = {
      method: 'GET'
    };


    fetch(url, options).then(function (response) {
      if (response.ok) {
        return response.json();
      }
    }).then(function (data) {
        if (self.props.match.params.demoid) {
          let demoid = self.props.match.params.demoid;
          self.state.currentPage = Util.FindNodeById(data, demoid);

          const params = new URLSearchParams(self.props.location.search);
          let devLang = params.get('devLang');
          self.state.codeMode = devLang == 'kotlin' ? 1 : 0;
        }

      if (data && data.children) {
        data.children.forEach(function (element) {
          element.topTreeNode = true;

          if (!element.children) {
            element.forceIcon = "treeNodePadding_menu";
          }
          else {
            // custom toggle style
            // var decorators = {};
            // var newIcon = element.toggled ? "fa fa-minus-square" : "fa fa-plus-square";
            // decorators.Toggle = ({ style }) => {
            //   return (
            //     <div style={style.base}>
            //       <div style={style.wrapper}>
            //         <i className={newIcon} aria-hidden="true"></i>
            //       </div>
            //     </div>
            //   );
            // };
            // element.decorators = decorators;

            // //custom toggle animations
            // var animations = {};
            // animations.toggle = ({ node: { toggled } }) => ({
            //   animation: { action: null },
            //   duration: 300
            // });
            // element.animations = animations;
          }
        }, this);
      }

      self.setState({ allTreeData: data, treeData: data });
    }).catch(function (error) {
      console.log('There has been a problem getting the navigation tree: ' + error.message);
    });
  }

  onTreeViewSelect(node, toggled){
    if(node && this.state.currentPage && node.id != this.state.currentPage.id){
      document.title = this.props.i18n.docTitle + ' | ' + node.name;
    }

    this.setHomeState(false);
    this.setState({ currentPage: node , mobileMenuIsShow: false});
    this.updateBodyScrollState(false);

  }

  onSearch(e) {
    const filterText = e.target.value.trim();
    if (filterText) {
      var filtered = Filter.filterTree(this.state.allTreeData, filterText);
      let result = Filter.expandFilteredNodes(filtered, filterText);
      this.setState({ treeData: result });
    } else {
      this.setState({ treeData: this.state.allTreeData });
    }
  }

  onClickHome() {
    document.title = this.props.i18n.docTitle 
    
    this.setHomeState(true);
    this.setState({mobileMenuIsShow: false});
    this.updateBodyScrollState(false);
    this.props.history.push(window.content_path);
  }

  setHomeState(isActive) {
    let homeNav = document.getElementById("scHome");
    if(!homeNav) {
      return;
    }
    if (isActive) {
      homeNav.classList.add("active");
    }
    else {
      homeNav.classList.remove("active");
    }
  }

  onHClickHideShowMenu() {
    this.setState({
      menuIsShow: !this.state.menuIsShow
    });
    // setTimeout(() => dispatchEvent('resize'));
  }

  // dispatchEvent(name){
  //   let evt;
  //   if (typeof Event === 'function') {
  //       evt = new Event(name);
  //   } else {
  //       evt = document.createEvent('UIEvents');
  //       evt.initUIEvent(name, true, false, window, 0);

  //   }
  //   window.dispatchEvent(evt);
  // }

  onMobileSideStateChanged(mobileMenuIsShow) {
      this.setState({ mobileMenuIsShow });
      this.updateBodyScrollState(mobileMenuIsShow);
    }

  updateBodyScrollState(state) {
        if (state) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'auto';
        }
  }

  render() {
    return (
      <div>
        <TopBar 
        lang={this.props.lang} 
        menuIsShow={this.state.menuIsShow} 
        mobileMenuIsShow={this.state.mobileMenuIsShow}
        topbarWidth={this.state.topbarWidth} 
        onSearch={this.onSearch} 
        onHClickHideShowMenu={this.onHClickHideShowMenu} 
        i18n={this.props.i18n} 
        onClickHome={this.onClickHome} 
        currentPage={this.state.currentPage} 
        treeData={this.state.treeData} 
        onToggleClick={this.onTreeViewSelect} 
        onMobileSideStateChanged={this.onMobileSideStateChanged.bind(this)}/>

      <div className="scContentContainer">
          <div className="scNavigatorDiv" data-treeview-hidden={!this.state.menuIsShow} data-treeview-mobile-hidden={!this.state.mobileMenuIsShow}>
            <div className="scTreeViewDiv" >
              <div className="scTreeView">
                <div id="scHome" className="scHome" onClick={this.onClickHome} >
                  {this.props.i18n.home}
                </div>
                <TreeView mobileMenuIsShow={this.state.mobileMenuIsShow} data={this.state.treeData.children} onSelect={this.onTreeViewSelect} codeMode={this.state.codeMode} setHomeState={this.setHomeState}/>
              </div>
            </div>

          </div>
          {this.state.currentPage ? (<Content i18n={this.props.i18n} lang={this.props.lang} codeMode={this.state.codeMode} page={this.state.currentPage} serverUrl={this.props.serverUrl} />) : (!this.props.match.params.demoid && <Welcome i18n={this.props.i18n} menuIsShow={this.state.menuIsShow}/>)}
      </div>

      <PageFooter i18n={this.props.i18n} lang={this.props.lang} />
      </div>
    );
  }
}

export default withRouter(Main);
